import { render, staticRenderFns } from "./ChatDemo.vue?vue&type=template&id=02737865&scoped=true&"
import script from "./ChatDemo.vue?vue&type=script&lang=js&"
export * from "./ChatDemo.vue?vue&type=script&lang=js&"
import style0 from "./ChatDemo.vue?vue&type=style&index=0&id=02737865&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02737865",
  null
  
)

export default component.exports